import React, { useState, useEffect } from 'react';

interface TechnologyNotesModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSave: (notes: string) => void;
    notes: string;
    techName: string;
}

export const TechnologyNotesModal: React.FC<TechnologyNotesModalProps> = ({
    isOpen,
    onClose,
    onSave,
    notes: initialNotes,
    techName
}) => {
    const [notes, setNotes] = useState(initialNotes);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setNotes(initialNotes);
    }, [initialNotes]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            await onSave(notes);
            onClose();
        } catch (error) {
            console.error('Error saving notes:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end z-50" onClick={onClose}>
            <div className="bg-white w-full max-w-md h-full shadow-xl" onClick={e => e.stopPropagation()}>
                <div className="p-6">
                    <div className="flex justify-between items-center mb-6">
                        <h2 className="text-xl font-bold text-[#0F2A4F]">{techName} - Notes</h2>
                        <button
                            onClick={onClose}
                            className="text-gray-500 hover:text-gray-700"
                        >
                            ✕
                        </button>
                    </div>

                    <form onSubmit={handleSubmit}>
                        <div className="mb-6">
                            <textarea
                                value={notes}
                                onChange={(e) => setNotes(e.target.value)}
                                className="w-full px-3 py-2 border border-gray-300 rounded-md h-64 focus:outline-none focus:ring-2 focus:ring-blue-500"
                                placeholder="Enter notes here..."
                            />
                        </div>

                        <div className="flex justify-end gap-3">
                            <button
                                type="button"
                                onClick={onClose}
                                className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="px-4 py-2 bg-[#0F2A4F] text-white rounded-md hover:bg-[#204374] disabled:opacity-50"
                            >
                                {isSubmitting ? 'Saving...' : 'Save Notes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};